import React from 'react'
import styles from './Guide.module.css'
import symptoms from '../../../assets/symptoms.svg'
import Precautions from '../../../assets/Precautions.svg'
import HomeReme from '../../../assets/HomeReme.svg'
import donate from '../../../assets/donate.svg'
import getVaccinated from '../../../assets/getVaccinated.svg'
import spread from '../../../assets/spread.svg'
import firstAid from '../../../assets/firstAid.svg'
import twitter from '../../../assets/twitter.svg'
import Cards from './Cards'


function OtherResource() {
    return (
        <div className={styles.component} id="covid19-guides">
            <div className={styles.componentCover}>
                <h1>Basic Covid-19 Guides</h1>

                <div className={styles.allGuides}>
                    <Cards image={symptoms} title="Symptoms" alternate="Symptoms" guidePage="/symptoms#"/>
                    <Cards image={Precautions} title="Precautions" alternate="Precautions" guidePage="/precautions"/>
                    <Cards image={HomeReme} title="Home Remedies" alternate="Home Remedies" guidePage="/homeRemedies"/>
                    <Cards image={donate} title="Donate Plasma" alternate="Donate Plasma" guidePage="/donate-plasma"/>
                </div>
                <div className={styles.allGuides}>
                    <Cards image={getVaccinated} title="Getting Vaccinated" alternate="Symptoms" guidePage="/getVaccinated"/>
                    <Cards image={twitter} title="All About Masks" alternate="Get help on twitter" guidePage="/allAboutMasks"/>
                    <Cards image={firstAid} title="First Aid at home" alternate="First Aid at home" guidePage="/first-aid-at-home"/>
                    <Cards image={spread} title="How It Spreads?" alternate="How It Spreads?" guidePage="/how-it-spreads"/>
                </div>
            </div>
        </div>
    )
}

export default OtherResource
